import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { initialState } from '../channelAddSlice'

const checkMobileUrl = createAxiosThunk(
  'channelAdd/checkMobileUrl',
  (noArgs, { getState }) =>
    api.channel.checkConnections(getState().channel.channelAdd.mobileUrl)
)

checkMobileUrl.reducers = builder => {
  builder.addCase(checkMobileUrl.pending, state => {
    state.isMobileUrlChecked = initialState.isMobileUrlChecked
  })

  builder.addCase(checkMobileUrl.fulfilled, state => {
    state.isMobileUrlChecked = true
  })

  builder.addCase(checkMobileUrl.rejected, (state, { payload }) => {
    state.isMobileUrlChecked = true
    state.apiError = payload
  })
}

export default checkMobileUrl
